import * as React from 'react';
import DeviceList from "../../components/deviceList/deviceList";
import deviceManagementService from "../../client-api/services/deviceManagement";
import UpdatesDrawer from "../../components/updatesDrawer/UpdatesDrawer";

const DeviceManagement = () => {
  const devices =  deviceManagementService.GetDevices();


  return (
    <div>
      <UpdatesDrawer/>
      <DeviceList devices={devices}/>
    </div>
)
}

export default DeviceManagement